export default {"src":"/_next/static/media/yes.10463cae.svg","height":21,"width":26};